import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { deleteInstitute } from '../api/institutes.api';

export function useDeleteInstitute() {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: (id: number) => deleteInstitute(id),
    onSuccess: () => {
      void refreshRelatedData('institute');
      toast.success('Institute deleted successfully');
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to delete institute');
    },
  });
}
